"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 * @preferred
 */
var service_1 = require("../service");
var _ = require("lodash");
var base_1 = require("./base");
var xhr_1 = require("../xhr");
var Webshop;
(function (Webshop) {
    function sendContactFrom(type, properties) {
        return new Promise(function (resolve, reject) {
            // Create our service instance
            //
            var service = new service_1.EVAService("SendContactForm");
            // Build the request data
            // The base class will add things like SessionID so to keep typescript
            // happy we're using an 'any' type object here
            //
            var requestData = {
                Type: type,
                Properties: properties,
                __response: null
            };
            // Perform the call and capture the resulting promise
            //
            service.call(requestData)
                .then(function (result) {
                resolve(_.get(result, "response"));
            })
                .catch(reject);
        });
    }
    Webshop.sendContactFrom = sendContactFrom;
})(Webshop = exports.Webshop || (exports.Webshop = {}));
var WebShopList = /** @class */ (function (_super) {
    __extends(WebShopList, _super);
    function WebShopList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns the current page identifier
     * @return {string}       The page identifier
     */
    WebShopList.prototype.getPageID = function () {
        return this.page_id;
    };
    /**
     * Set the make up page identifier
     * @param  {string} page_id The page identifier
     * @return {string}         The currently page identifier
     */
    WebShopList.prototype.setPageID = function (page_id) {
        return this.page_id = page_id;
    };
    /**
     * Fetches the list of items
     * @return {Promise<IEVAServiceResponse<EVA.Core.Services.ListOrganizationUnits, EVA.Core.Services.ListOrganizationUnitsByTypeResponse>>} A promise resolving when the fetch from the back-end has completed
     */
    WebShopList.prototype.fetch = function () {
        // Build the request data
        //
        var requestData = {
            OrganizationUnitTypes: 2,
            IncludeParentApplications: undefined,
            PageConfig: undefined,
        };
        // Apply PageConfig parameters directly
        //
        _.assign(requestData, _.omit(this.getPageConfiguration(), ["Filter"]));
        return _super.prototype.fetch.call(this, "ListOrganizationUnits", requestData, "/api/v1/organization/type", xhr_1.EXMLHttpRequestMethod.GET);
    };
    return WebShopList;
}(base_1.FetchablePagedList));
exports.WebShopList = WebShopList;
